import { createFromIconfontCN } from '@ant-design/icons'

const IconFont = createFromIconfontCN({
  scriptUrl: '/js/font_4474609_hgn983e3qp.js',
})

export default IconFont
